<template>
  <div>
    <portlet
      :icon="'fas fa-users portlet-icon'"
      :title="$t('engagement.employeeindepth')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20"
    >
      <template slot="actionsBlock">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <i class="fas fa-long-arrow-left mr-2"></i> Back
        </button>
      </template>

      <template slot="portletBody">
        <div class="container-fluid">
          <div class="row profile_img mx-auto">
            <img
              src="https://www.medtalks.nl/images/user-placeholder.jpg"
              class="img-fluid rounded-circle"
              alt="profile picture"
            />
          </div>
          <div class="row pt-2 mx-auto justify-content-center">
            <h2>{{ user.displayName }}</h2>
          </div>
          <!-- {{ engagement.uwesChart }}
          <br /> -->
          
          <engagementScale v-if="engagement.uwes !== null" :engagement="engagement" />
          <!-- <performanceScale /> -->
          <evaluationScale
            v-if="engagement.evaluation !== null"
            :engagement="engagement"
          />
        </div>
      </template>
    </portlet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import engagementScale from "@/components/engagement/inDepth/engagementScale.vue";
import performanceScale from "@/components/engagement/inDepth/performanceScale.vue";
import evaluationScale from "@/components/engagement/inDepth/evaluationScale.vue";

import { evaluationMethods } from "@/mixins/engagement/evaluationMethods.js";
import { engagementScaleMethods } from "@/mixins/engagement/engagementScaleMethods.js";
import { employeeEngagementMethods } from "@/mixins/engagement/employeeEngagementMethods.js";
import { adjustColor } from "@/mixins/engagement/adjustChartColor.js";

export default {
  mixins: [
    evaluationMethods,
    engagementScaleMethods,
    employeeEngagementMethods,
    adjustColor,
  ],
  components: {
    engagementScale,
    performanceScale,
    evaluationScale,
  },
  data() {
    return {
      user: {},
      engagement: {
        employeeEngagement: null,
        employeeEngagementChart: null,
        uwes: null,
        uwesChart: null,
        uwesSubCharts: {
          vigor: null,
          absorption: null,
          dedication: null,
        },
        evaluation: null,
        evaluationChart: null,
        evaluationSubCharts: {
          communication: null,
          relationships: null,
          planning: null,
          results: null,
          resilience: null,
          supporting: null,
          progression: null,
        },
        
        chartOptions: {
          responsive: true,
          maintainAspectRatio: true,
          cutoutPercentage: 60,
          legend: {
            display: false,
          },
          tooltips: false,
          plugins: {
            datalabels: {
              display: function (ctx) {
                return false;
              },
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("userData", ["getMyDepartments"]),
    ...mapGetters("users", ["getMe", "getClaims"]),
    ...mapGetters("uwes", ["getUwes"]),
    ...mapGetters("evaluation", ["getEvaluation", "getEvaluationByUserId"]),
  },
  mounted() {},
  methods: {
    async setUwesData() {
      const where = [
        ["userId", "==", this.$route.params.userId],
        ["companyId", "==", this.getClaims.companyId],
      ];
      const orderBy = ["created_at", "desc"];
      await this.$store
        .dispatch("uwes/fetchAndAdd", { clauses: { where, orderBy, limit: 1 } })
        .catch((e) => {});
      let uwesData = await this.getUwes(this.$route.params.userId);
      if (uwesData && uwesData !== undefined) {
        this.engagement.uwes = await this.getEngagementScale(uwesData);
        this.engagement.uwesChart = await this.getChartDataEngagamentScale(
          this.engagement.uwes
        );
        // console.log(this.engagement.uwes.engagementSubscale.vigorPercentage)
        this.engagement.uwesSubCharts.vigor = await this.addChartData(this.engagement.uwes.engagementSubscale.vigorPercentage)
        this.engagement.uwesSubCharts.absorption = await this.addChartData(this.engagement.uwes.engagementSubscale.absorptionPercentage)
        this.engagement.uwesSubCharts.dedication = await this.addChartData(this.engagement.uwes.engagementSubscale.dedicationPercentage)
      }
      this.updateEEI();
      return;
    },

    async addChartData(value) {
      return {
        datasets: [
          {
            data: [value, 100 - value],
            backgroundColor: [this.adjustColor(value)],
            borderWidth: 0,
          }],
        
        labels: [""],
      };

      // return chartData;
    },

    async setEvaluationData() {
      const where = [
        ["evaluatee.uid", "==", this.$route.params.userId],
        ["companyId", "==", this.getClaims.companyId],
      ];
      const orderBy = ["created_at", "desc"];
      await this.$store
        .dispatch("evaluation/fetchAndAdd", { clauses: { where, orderBy } })
        .catch((e) => {});
      let evaluationData = await this.getEvaluationByUserId(this.$route.params.userId);

      if (evaluationData && evaluationData !== undefined) {
        this.engagement.evaluation = await this.getEvaluationScore(
          evaluationData
        );
        if (this.engagement.evaluation !== "inProgress") {
          this.engagement.evaluationChart =
            await this.getChartDataEvaluationScale(this.engagement.evaluation);
            this.engagement.evaluationSubCharts.communication = await this.addChartData(this.engagement.evaluation.evaluationSubscale.communicationPercentage)
            this.engagement.evaluationSubCharts.relationships = await this.addChartData(this.engagement.evaluation.evaluationSubscale.relationshipPercentage)
            this.engagement.evaluationSubCharts.planning = await this.addChartData(this.engagement.evaluation.evaluationSubscale.planningPercentage)
            this.engagement.evaluationSubCharts.results = await this.addChartData(this.engagement.evaluation.evaluationSubscale.resultsPercentage)
            this.engagement.evaluationSubCharts.resilience = await this.addChartData(this.engagement.evaluation.evaluationSubscale.resiliencePercentage)
            this.engagement.evaluationSubCharts.supporting = await this.addChartData(this.engagement.evaluation.evaluationSubscale.supportingPercentage)
            this.engagement.evaluationSubCharts.progression = await this.addChartData(this.engagement.evaluation.evaluationSubscale.progressionPercentage)
          

          this.updateEEI();
        }
      }

      return;
    },

    async updateEEI() {
      if (this.engagement.uwes && this.engagement.evaluation) {
        this.engagement.employeeEngagement =
          this.getEmployeeEngagementIndicationScore(
            this.engagement.uwes,
            this.engagement.evaluation
          );
        // console.log(this.engagement.employeeEngagement);
        this.engagement.employeeEngagementChart = this.getChartDataEEI(
          this.engagement.employeeEngagement
        );
        // console.log(this.engagement.employeeEngagementChart);
      }
    },
  },
  async created() {
    this.$store.commit("setLoading", true);
    this.$FUNCTIONS
      .Users("getUserById", this.$route.params.userId)
      .then((res) => {
        this.user = res.data;
        this.$store.commit("setLoading", false);
      })
      .catch((e) => {
        this.$store.commit("setLoading", false);
      });

    let uwesData = await this.getUwes(this.user.uid);
    if (!uwesData) {
      await this.setUwesData();
    } else {
      this.engagement.uwes = await this.getEngagementScale(uwesData);
      this.engagement.uwesChart = await this.getChartDataEngagamentScale(
        this.engagement.uwes
      );
    }

    let evaluationData = await this.getEvaluation(this.$route.params.userId);
    if (!evaluationData) {
      await this.setEvaluationData();
    } else {
      this.engagement.evaluation = await this.getEvaluationScore(
        evaluationData
      );
      // this.engagement.evaluationChart = await this.getChartDataEngagamentScale(
      //   this.engagement.evaluation
      // );
    }
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>
